import React from 'react'
import { MapApiProps } from '../types'

const useMapApi = (): MapApiProps => {
    const [scriptsLoaded, setScriptsLoaded] = React.useState(false)

    React.useEffect(() => {
        if (!scriptsLoaded) {
            const mapsURL = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=geometry,places&language=cs&region=CZ&v=quarterly`
            const scripts = document.getElementsByTagName('script')
            for (let i = 0; i < scripts.length; i++) {
                if (scripts[i].src.indexOf(mapsURL) === 0) {
                    setScriptsLoaded(true)
                    return
                }
            }

            const googleMapScript = document.createElement('script')
            googleMapScript.src = mapsURL
            googleMapScript.async = true
            googleMapScript.defer = true
            googleMapScript.addEventListener('load', () => setScriptsLoaded(true))
            window.document.body.appendChild(googleMapScript)
        }
    }, [scriptsLoaded])

    return {
        scriptsLoaded,
    }
}
export default useMapApi
